import { render } from "./UploadExcel.vue?vue&type=template&id=76f5833f"
import script from "./UploadExcel.vue?vue&type=script&lang=ts"
export * from "./UploadExcel.vue?vue&type=script&lang=ts"
script.render = render

export default script